import { Close, FilterListOutlined } from "@mui/icons-material";
import { Box, Divider, FormControl, Typography, useTheme } from "@mui/material";
import { DateFilter, DropdownFilter } from "@pimo/pimo-components";
import {
  BUSINESS_UNIT_TYPE,
  CATEGORY_TYPES,
  InitiativeFilterData,
  InitiativeFilterOptions,
} from "aint-types";
import { FC } from "react";

export interface InitiativesStatusTableFilterDialogProps {
  onClick?: () => void;
  handleChange: (
    event: React.ChangeEvent<HTMLInputElement> | { target: { value: string } },
    trigger: string
  ) => void;
  filterData: InitiativeFilterData;
  filterOptions: InitiativeFilterOptions;
  showCategoryFilter: boolean;
  showBusinessUnitFilter: boolean;
}

export const InitiativesStatusTableFilterDialog: FC<
  InitiativesStatusTableFilterDialogProps
> = ({
  onClick,
  handleChange,
  filterData,
  filterOptions,
  showCategoryFilter,
  showBusinessUnitFilter,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: 1,
        gap: 0,
        width: 300,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "start",
            width: "100%",
            pr: 1,
          }}
        >
          <FilterListOutlined />
          <Typography sx={{ fontWeight: 500 }}>Filter</Typography>
        </Box>
        <Close onClick={onClick}></Close>
      </Box>
      <Divider
        sx={{
          bgcolor: theme.palette.secondary.main,
          height: "1px",
          borderWidth: 0,
        }}
      />
      <FormControl
        component="fieldset"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          paddingY: "8px",
        }}
      >
        {/* Text Filter, year */}
        <DateFilter
          views={["year"]}
          value={filterData.yearFilter ?? ""}
          label="Year"
          triggerIdentifier="yearFilter"
          handleChange={handleChange}
        />
        <Divider
          sx={{
            bgcolor: theme.palette.secondary.main,
            height: "1px",
            borderWidth: 0,
          }}
        />
        {/* Dropdown phase */}
        <DropdownFilter
          options={filterOptions.phase ?? []}
          value={filterData.phaseFilter ?? []}
          label="Initiative Phase"
          handleChange={handleChange}
          triggerIdentifier={"phaseFilter"}
        />
        <Divider
          sx={{
            bgcolor: theme.palette.secondary.main,
            height: "1px",
            borderWidth: 0,
          }}
        />
        {/* Dropdown update status */}
        <DropdownFilter
          options={filterOptions.updateStatus ?? []}
          value={filterData.updateStatusFilter ?? []}
          label="Update Status"
          handleChange={handleChange}
          triggerIdentifier={"updateStatusFilter"}
        />
        <Divider
          sx={{
            bgcolor: theme.palette.secondary.main,
            height: "1px",
            borderWidth: 0,
          }}
        />
        {/* Dropdown Business Unit */}
        {showBusinessUnitFilter && (
          <>
            <DropdownFilter
              options={BUSINESS_UNIT_TYPE.map((type) => type)}
              value={filterData.businessUnitFilter ?? []}
              label="Business Unit"
              handleChange={handleChange}
              triggerIdentifier={"businessUnitFilter"}
            />
            <Divider
              sx={{
                bgcolor: theme.palette.secondary.main,
                height: "1px",
                borderWidth: 0,
              }}
            />{" "}
          </>
        )}
        {/* Dropdown Line of Business */}
        <DropdownFilter
          options={filterOptions.lineOfBusiness ?? []}
          value={filterData.lineOfBusinessFilter ?? []}
          label="Line of Business"
          handleChange={handleChange}
          triggerIdentifier={"lineOfBusinessFilter"}
        />
        {/* Dropdown Category */}
        {showCategoryFilter && (
          <>
            <Divider
              sx={{
                bgcolor: theme.palette.secondary.main,
                height: "1px",
                borderWidth: 0,
              }}
            />
            <DropdownFilter
              options={CATEGORY_TYPES.map((type) => type)}
              value={filterData.categoryFilter ?? []}
              label="Category"
              handleChange={handleChange}
              triggerIdentifier={"categoryFilter"}
            />{" "}
          </>
        )}
      </FormControl>
    </Box>
  );
};
